/* global window, document, Tabulator */

(function (window, document) {
    var root = document.getElementById('radar-trend-root');
    if (!root) return;

    function qs(sel, el) { return (el || document).querySelector(sel); }
    function setStatus(msg) { var el = qs('[data-radar-status]', root); if (el) el.textContent = msg || ''; }

    function parseEuroNumber(v) {
        if (v == null || v === '') return NaN;
        if (typeof v === 'number' && isFinite(v)) return v;
        var s = String(v).trim().replace(/\s/g, '');
        if (!s) return NaN;
        if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) return parseFloat(s.replace(/\./g, '').replace(',', '.'), 10);
        if (s.indexOf(',') !== -1) return parseFloat(s.replace(',', '.'), 10);
        return parseFloat(s, 10);
    }
    function formatEuroIt(v) {
        var n = parseEuroNumber(v);
        if (!isFinite(n)) return '—';
        return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function readFilters() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return {};
        var fd = new FormData(form);
        var out = {};
        var days = fd.get('days');
        if (days) out.days = String(days).trim();
        return out;
    }

    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var client = new window.AppaltiMap.ApiGatewayClient({
        baseUrl: apiBase,
        tokenStore: new window.AppaltiMap.TokenStore('appaltimap_auth')
    });

    var table;
    function buildTable() {
        if (typeof Tabulator === 'undefined') { setStatus('Tabulator non disponibile.'); return; }
        var el = qs('#radar-trend-table', root);
        if (!el || table) return;

        table = new Tabulator(el, {
            layout: 'fitColumns',
            placeholder: 'Nessun dato',
            columns: [
                { title: 'Data', field: 'date', width: 120 },
                { title: 'Aziende attive', field: 'active_companies', width: 140, hozAlign: 'right' },
                { title: 'Partecipazioni', field: 'participations_total', width: 140, hozAlign: 'right' },
                { title: 'Vittorie', field: 'wins_total', width: 100, hozAlign: 'right' },
                { title: 'Importo agg. €', field: 'awarded_amount_eur_sum', width: 140, hozAlign: 'right', formatter: function (c) { return formatEuroIt(c.getValue()); } }
            ]
        });
        root._vgTabulator = table;
    }

    function load() {
        buildTable();
        if (!table) return;
        var f = readFilters();
        setStatus('Caricamento…');
        return client.get(apiBase + '/radar/trend?' + new URLSearchParams(f).toString())
            .then(function (data) {
                var rows = (data && data.series) || [];
                table.setData(rows);
                setStatus('');
            })
            .catch(function () {
                setStatus('Impossibile caricare.');
            });
    }

    // Add a minimal helper on client if missing (older bundle).
    if (!client.get) {
        client.get = function (url) {
            var token = client.tokenStore.getToken() || '';
            var headers = { Accept: 'application/json' };
            if (token) headers.Authorization = 'Bearer ' + token;
            return fetch(url, { headers: headers }).then(function (r) { if (!r.ok) throw r; return r.json(); });
        };
    }

    load();
    var form = qs('[data-radar-filters]', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); load(); });
})(window, document);

